import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmFollow } from '../header/LawFirmFollow';
import { BigLineSeparator } from '../../../components/separator/LineSeparator';
import { LawFirmHeaderInfos } from '../header/LawFirmHeaderInfos';
import '../header/law_firm_header.scss';
import { Office } from '../../lawFirm.types';
import { FirmHeaderDecisionsLink } from '../header/FirmHeaderDecisionsLink';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';

type Props = {
  firmName: string;
  dateRadiation: string | null;
  decisionCount: number;
  allDecisionsLink: string;
  office: Office;
  lawOfficeIdGroup: string;
};

export const UniqueLawFirmHeader: FC<Props> = ({
  firmName,
  dateRadiation,
  decisionCount,
  allDecisionsLink,
  office,
  lawOfficeIdGroup,
}) => (
  <EntityCardHeader id="law-firm-header">
    <div className="law-firm-header__top-container">
      <div
        className="entity__header__picture law-firm-header__picture"
        style={{ backgroundImage: 'url(/img/icons/entities/law-firm.svg)' }}
      />
      <div className="law-firm-header__title-container">
        <h1 className="entity__header__title law-firm-header__title">
          {firmName}
        </h1>
        <span className="law-firm-header__title-info">
          <FormattedMessage id="law-firm/page/unique/UniqueLawFirmHeader.tsx/1" />{' '}
          {dateRadiation ? (
            <span className="law-firm-header__info-important">
              <FormattedMessage
                id="law-firm/page/unique/UniqueLawFirmHeader.tsx/2"
                values={{ date: dateRadiation }}
              />
            </span>
          ) : (
            ''
          )}
        </span>
        <FirmHeaderDecisionsLink
          decisionCount={decisionCount}
          allDecisionsLink={allDecisionsLink}
        />
        <LawFirmFollow
          lawOfficeIdGroup={lawOfficeIdGroup}
          firmName={firmName}
        />
      </div>
    </div>
    <BigLineSeparator />
    <LawFirmHeaderInfos office={office} />
  </EntityCardHeader>
);
